import { webKnots } from '../../../../common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartOfWeb } from './parts/verticalParts'

export const wi9Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // ウェブ_縦
  verticalPartOfWeb(ctx, webColor, laceColor, stitchColor)
  webKnots(ctx, laceColor, -115, 125) // 捕球面上のウェブ結び目
}
